module.exports = __webpack_public_path__ + "gi.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gi.svg
// module id = 567
// module chunks = 0